import { Box } from 'native-base';

export const Separator = () => <Box width="full" h="1px" bg="neutral.lightest" />;
